import React from "react";

const DownloadCircle = ({
    width = 36,
    height = 36,
    color = "#E7730A",
    ...rest
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path d="M23.7611 17.397L19.125 22.0342V10.125C19.125 9.504 18.621 9 18 9C17.379 9 16.875 9.504 16.875 10.125V22.0342L12.2389 17.3981C11.799 16.9582 11.0869 16.9582 10.6481 17.3981C10.2082 17.838 10.2082 18.5501 10.6481 18.9888L17.0122 25.3529C17.2822 25.6229 17.6512 25.7062 18.0012 25.6443C18.3499 25.7062 18.7201 25.6218 18.9901 25.3529L25.3542 18.9888C25.7941 18.5489 25.7941 17.8369 25.3542 17.3981C24.9131 16.9582 24.201 16.9582 23.7611 17.397ZM18 0C8.05953 0 0 8.05835 0 18C0 27.9416 8.05953 36 18 36C27.9405 36 36 27.9405 36 18C36 8.05953 27.9416 0 18 0ZM18 33.75C9.30147 33.75 2.25 26.6985 2.25 18C2.25 9.30147 9.30147 2.25 18 2.25C26.6985 2.25 33.75 9.30147 33.75 18C33.75 26.6985 26.6985 33.75 18 33.75Z" fill={color} />
        </svg>
    )
}

export default DownloadCircle;